var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.66,
    height: 26.59,
    viewBox: "0 0 25.66 26.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.49,25.73l-3.16-3.27V12.69a1.24,1.24,0,0,0-.34-.86L15.12,3.68a8,8,0,0,0-11.56,0,8.68,8.68,0,0,0,0,12h0l7.86,8.16a1.15,1.15,0,0,0,.83.36h9.43l3.16,3.27a1.14,1.14,0,0,0,1.65,0A1.23,1.23,0,0,0,26.49,25.73ZM5.21,13.94a6.2,6.2,0,0,1,0-8.55,5.7,5.7,0,0,1,8.26,0L21,13.19V20L10.16,8.81a1.14,1.14,0,0,0-1.65,0,1.23,1.23,0,0,0,0,1.71l6.17,6.4H8.1l-2.89-3Zm7.52,7.81-2.32-2.42H17l2.33,2.42Z",
    transform: "translate(-1.17 -1.2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateIcon);
export default __webpack_public_path__ + "static/media/EstateIcon.7b454fab8ce9e1d03e5c157164bc74e6.svg";
export { ForwardRef as ReactComponent };